import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import myImage from "./logo.jpeg";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // For mobile menu toggle
  const [activeDropdown, setActiveDropdown] = useState(null); // Track the active dropdown

  const [showNewBadge, setShowNewBadge] = useState(true);
  const [isNewEvent, setIsNewEvent] = useState(true);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".navbar-container")) {
        setIsMenuOpen(false);
        setActiveDropdown(null);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

 

  // Toggle dropdown menus on click
  const handleDropdownToggle = (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  // Close menu when a dropdown is clicked in mobile view
  const handleLinkClick = () => {
    setIsMenuOpen(false);
    setActiveDropdown(null);
  };

  return (
    <div className="navbar-container">
      {/* Title and Logo Section */}
      <div className="title-subtitle-container">
        <div className="logo-container">
        <Link to="/" onClick={handleLinkClick}>
          <img src={myImage} alt="Logo" className="navbar-logo" />
        </Link>
        </div>
        <div className="title-center-container">
          <h1 className="navbar-title">TISS ALUMS ASSOCIATION (TISSAA)</h1>
          <p className="navbar-subtitle">Apex body of all the alums across the courses, campuses and batches...</p>
        </div>
      </div>

      {/* Navbar Section */}
      <nav className="navbar">
        {/* Mobile Menu Toggle Button */}
        <button className="toggle-button" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          &#9776;
        </button>

        {/* Navigation Links */}
        <ul className={`nav-links ${isMenuOpen ? "active" : ""}`}>
          <li>
            <Link to="/" onClick={handleLinkClick}>HOME</Link>
          </li>
          <li className="dropdown">
            <Link to="/about" onClick={() => handleDropdownToggle("about")}>ABOUT US</Link>
            <ul className={`dropdown-content ${activeDropdown === "about" ? "show" : ""}`}>
              <li><Link to="/about#genesis" onClick={handleLinkClick}>Genesis</Link></li>
              <li><Link to="/about#message" onClick={handleLinkClick}>Message</Link></li>
              <li><Link to="/about#purpose" onClick={handleLinkClick}>Purpose</Link></li>
              <li><Link to="/about#objectives" onClick={handleLinkClick}>Objectives</Link></li>
              <li><Link to="/about#trustees" onClick={handleLinkClick}>Trustees</Link></li>
              <li><Link to="/about#managingCommitteeMembers" onClick={handleLinkClick}>Managing Committee Members</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <Link to="/engagement/alumni-meet" onClick={() => handleDropdownToggle("engagement")}>ALUMS ENGAGEMENT</Link>
            <ul className={`dropdown-content ${activeDropdown === "engagement" ? "show" : ""}`}>
              <li><Link to="/engagement/alumni-meet" onClick={handleLinkClick}>Alums Meet</Link></li>
              <li><Link to="/engagement/AlumsCare" onClick={handleLinkClick}>Alums Care</Link></li>
              <li><Link to="/engagement/SIG" onClick={handleLinkClick}>SIG</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <Link to="/development/vaani" onClick={() => handleDropdownToggle("development")}>ALUMS DEVELOPMENT</Link>
            <ul className={`dropdown-content ${activeDropdown === "development" ? "show" : ""}`}>
              <li><Link to="/development/vaani" onClick={handleLinkClick}>TISSAA-VAANI</Link></li>
              <li><Link to="/development/Capacity" onClick={handleLinkClick}>Capacity Building</Link></li>
              <li><Link to="/development/Collaboration" onClick={handleLinkClick}>C2</Link></li>
              <li><Link to="/development/Regional" onClick={handleLinkClick}>Regional Partnership</Link></li>
              <li><Link to="/development/Promoting" onClick={handleLinkClick}>Promoting Alums</Link></li>
              <li><Link to="/development/Job" onClick={handleLinkClick}>Job Portal</Link></li>
            </ul>
          </li>
          <li className="dropdown">
            <Link to="/media/Photo" onClick={() => handleDropdownToggle("media")}>MEDIA</Link>
            <ul className={`dropdown-content ${activeDropdown === "media" ? "show" : ""}`}>
              <li><Link to="/media/Photo" onClick={handleLinkClick}>Photo </Link></li>
              <li><Link to="/media/Video" onClick={handleLinkClick}>Video</Link></li>
              <li><Link to="/media/Reports" onClick={handleLinkClick}>Reports</Link></li>
              <li className="dropdown">
                <Link to="/media/upcoming-events" onClick={(e) => {e.preventDefault(); handleDropdownToggle("mediaCoverage");}}>Media Coverage</Link>
                {activeDropdown === "mediaCoverage" && (
                <ul className="dropdown-content">
                  <li><Link to="/media/print" onClick={handleLinkClick}>Print Media</Link></li>
                  <li><Link to="/media/Electronic" onClick={handleLinkClick}>Electronic Media</Link></li>
                  <li><Link to="/media/Social" onClick={handleLinkClick}>Social Media</Link></li>
                </ul>
                  )}
               </li>
              <li><Link to="/media/past-events" onClick={handleLinkClick}>Other</Link></li>
            </ul>
          </li>
          <li className="nav-item" style={{ position: 'relative' }}>
          {showNewBadge && isNewEvent && (
            <span className="new-badge">New</span>
          )}
          <Link to="/Event" className="event-link" onClick={() => setShowNewBadge(false)} > EVENT</Link> </li>
          <li className="dropdown">
            <Link to="/joinus" onClick={() => handleDropdownToggle("joinus")}>JOIN US</Link>
            <ul className={`dropdown-content ${activeDropdown === "joinus" ? "show" : ""}`}>
              <li><Link to="/membership" onClick={handleLinkClick}>Membership</Link></li>
              <li><Link to="/donation" onClick={handleLinkClick}>Donation</Link></li>
            </ul>
          </li>
          
          <li><Link to="/login" onClick={handleLinkClick}>LOGIN</Link></li>
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
